import _objectSpread from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-b594018a"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 查询 ");

const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 重置 ");

const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 批量兑换 ");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("导出Excel");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("兑换");

const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 积分流水 ");

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "dialog-desc"
}, " 批量兑换将结清已选中业务员的可兑换积分, 一旦兑换不可撤回, 是否确认批量兑换? ", -1));

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "dialog-warn"
}, [/*#__PURE__*/_createElementVNode("p", null, "注意"), /*#__PURE__*/_createElementVNode("p", null, "1. 可兑换的积分为截止到上个自然月的订单积分。"), /*#__PURE__*/_createElementVNode("p", null, "2. 积分一旦兑换不可撤回, 如要追溯积分使用情况, 建议导出积分明细的Excel表格。")], -1));

const _hoisted_9 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 确认 ");

const _hoisted_11 = {
  style: {
    "margin-bottom": "10px",
    "color": "#999"
  }
};

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "dialog-warn"
}, [/*#__PURE__*/_createElementVNode("p", null, "注意"), /*#__PURE__*/_createElementVNode("p", null, "1. 兑换数量不可大于业务员可兑换积分。"), /*#__PURE__*/_createElementVNode("p", null, "2. 可兑换积分数为截止到上个自然月的订单积分。")], -1));

const _hoisted_13 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_14 = /*#__PURE__*/_createTextVNode("确认");

import { ref, watch } from 'vue';
import { getVexTableProps } from '@/config';
import { getSalesmanIntegralInfoList, getCatalog, getSalesmanTypeList, integralExchange, batchIntegralExchange, exportForAsync } from '@/request';
import { ElMessage } from 'element-plus';
import { exportSalesmanIntegralInfoList } from '@/request/api';
import { eachObj } from '@/utils';
import PointTurnoverModal from './component/PointTurnoverModal.vue';
export default {
  name: 'SalesmanPoints',
  props: {
    integralMode: String
  },

  setup(__props) {
    const props = __props;
    const form = ref({
      supplierName: '',
      supplierCategory: '',
      linkMan: '',
      businessCategory: '',
      linkPhone: ''
    });
    const table = ref();
    const showBatchExchangeModal = ref(false);
    const showPointExchangeModal = ref(false);
    const showPointTurnoverModal = ref(false);
    const selectedRow = ref(null);
    const exchangePointNum = ref(0);
    const teamTypes = ref([]);
    let total = 0;
    getCatalog({
      type: 'supplierCategory'
    }).then(data => {
      if (data) {
        teamTypes.value = [{
          text: '全部',
          value: ''
        }, ...data];
      }
    });
    const salesmanTypeList = ref([]);
    getSalesmanTypeList().then(data => {
      salesmanTypeList.value = [{
        text: '全部',
        id: ''
      }, ...data];
    });

    function exportExcel() {
      let fileName = props.integralMode === '1' ? '团队业务积分明细' : '平台业务积分明细';
      exportForAsync(_objectSpread(_objectSpread({
        __repeat: true,
        __warn: true
      }, form.value), {}, {
        modularflag: 'salesmanIntegral',
        fileName,
        count: total,
        methodName: exportSalesmanIntegralInfoList.url,
        integralMode: props.integralMode
      }));
    }

    function reset() {
      form.value = {
        supplierName: '',
        supplierCategory: '',
        linkMan: '',
        businessCategory: '',
        linkPhone: ''
      };
      table.value.commitProxy('reload');
    }

    watch(() => showPointExchangeModal.value, newVal => {
      if (!newVal) {
        selectedRow.value = null;
        exchangePointNum.value = 0;
      }
    });

    function pointEchange(row) {
      selectedRow.value = row;
      showPointExchangeModal.value = true;
    }

    function getPointTurnover(row) {
      selectedRow.value = row;
      showPointTurnoverModal.value = true;
    }

    function confirmPointExchange() {
      if (exchangePointNum.value <= 0 || exchangePointNum.value > Number(selectedRow.value.redeemableIntegral)) {
        ElMessage.warning(`当前业务员可兑换积分范围为0~${selectedRow.value.redeemableIntegral}`);
        return;
      }

      integralExchange({
        supUserId: selectedRow.value.supUserId,
        integralNumber: exchangePointNum.value,
        integralMode: props.integralMode,
        __warn: true,
        __repeat: true
      }).then(data => {
        if (data.success) {
          showPointExchangeModal.value = false;
          ElMessage.success('兑换成功!');
          table.value.commitProxy('query');
        }
      });
    }

    function batchExchangePoint() {
      const selectRows = table.value.getCheckboxRecords();

      if (!selectRows.length) {
        ElMessage.warning('请勾选后再进行操作!');
        return;
      }

      showBatchExchangeModal.value = true;
    }

    function confirmBatchExchangePoint() {
      const selectRows = table.value.getCheckboxRecords();
      batchIntegralExchange({
        supUserIds: selectRows.map(i => i.supUserId),
        integralMode: props.integralMode,
        __warn: true,
        __repeat: true
      }).then(data => {
        if (data.success) {
          ElMessage.success('批量兑换成功!');
          showBatchExchangeModal.value = false;
          table.value.commitProxy('query');
        }
      });
    }

    const tableOptions = getVexTableProps({
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      },
      columns: [{
        type: 'checkbox',
        width: '50px',
        fixed: 'left'
      }, {
        title: '业务员',
        field: 'linkMan',
        width: '150px',
        showOverflow: true
      }, {
        title: '手机号',
        field: 'linkPhone',
        width: '150px',
        showOverflow: true
      }, {
        title: '所属团队',
        field: 'supplierName',
        width: '200px',
        showOverflow: true
      }, {
        title: '业务员类型',
        field: 'businessCategory',
        width: '150px',
        showOverflow: true
      }, {
        title: '可兑换积分',
        field: 'redeemableIntegral',
        width: '150px',
        showOverflow: true
      }, {
        title: '已兑换积分',
        field: 'exchangeIntegral',
        width: '150px',
        showOverflow: true
      }, {
        title: '剩余积分',
        field: 'remainIntegral',
        width: '200px',
        showOverflow: true,
        slots: {
          header: 'surplusPointHeader'
        }
      }, {
        title: '操作',
        field: 'operation',
        fixed: 'right',
        width: '250px',
        slots: {
          default: 'operation'
        }
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getSalesmanIntegralInfoList(_objectSpread({
              page: page.currentPage,
              pageSize: page.pageSize,
              integralMode: props.integralMode
            }, form.value)).then(data => {
              total = data.data.totalSize;
              res({
                total: data.data.totalSize,
                result: data.data.salesmanIntegralInfoVos
              });
            });
          })
        }
      }
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_form = _resolveComponent("el-form");

      const _component_InfoFilled = _resolveComponent("InfoFilled");

      const _component_el_icon = _resolveComponent("el-icon");

      const _component_el_tooltip = _resolveComponent("el-tooltip");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_dialog = _resolveComponent("el-dialog");

      const _component_el_input_number = _resolveComponent("el-input-number");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_form, {
        model: form.value,
        "label-width": "100px"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "团队名称"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.supplierName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.supplierName = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "团队类型"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: form.value.supplierCategory,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.supplierCategory = $event)
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teamTypes.value, type => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    label: type.text,
                    value: type.value,
                    key: type.value
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "业务员名称"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.linkMan,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.linkMan = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "业务员类型"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: form.value.businessCategory,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.businessCategory = $event)
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(salesmanTypeList.value, item => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    label: item.text,
                    value: item.id,
                    key: item.id
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "业务员手机"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.linkPhone,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.value.linkPhone = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, {
          justify: "end"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            icon: "Search",
            onClick: _cache[5] || (_cache[5] = $event => table.value.commitProxy('reload'))
          }, {
            default: _withCtx(() => [_hoisted_1]),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "primary",
            icon: "Refresh",
            onClick: reset
          }, {
            default: _withCtx(() => [_hoisted_2]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"]), _createVNode(_component_vxe_grid, _mergeProps(_unref(tableOptions), {
        ref_key: "table",
        ref: table
      }), {
        tools: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: batchExchangePoint
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        }), _createVNode(_component_el_button, {
          icon: "Download",
          onClick: exportExcel
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        })]),
        surplusPointHeader: _withCtx(({
          column
        }) => [_createElementVNode("span", null, [_createTextVNode(_toDisplayString(column.title) + " ", 1), _createVNode(_component_el_tooltip, {
          content: "截止到今日, 业务员积分账号剩余积分",
          placement: "bottom"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, {
            size: 15
          }, {
            default: _withCtx(() => [_createVNode(_component_InfoFilled)]),
            _: 1
          })]),
          _: 1
        })])]),
        operation: _withCtx(({
          row
        }) => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: $event => pointEchange(row)
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 2
        }, 1032, ["onClick"]), _createVNode(_component_el_button, {
          type: "success",
          icon: "Coin",
          onClick: $event => getPointTurnover(row)
        }, {
          default: _withCtx(() => [_hoisted_6]),
          _: 2
        }, 1032, ["onClick"])]),
        _: 1
      }, 16), _createVNode(_component_el_dialog, {
        title: "批量兑换",
        modelValue: showBatchExchangeModal.value,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => showBatchExchangeModal.value = $event)
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[6] || (_cache[6] = $event => showBatchExchangeModal.value = false)
        }, {
          default: _withCtx(() => [_hoisted_9]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirmBatchExchangePoint
        }, {
          default: _withCtx(() => [_hoisted_10]),
          _: 1
        })]),
        default: _withCtx(() => [_hoisted_7, _hoisted_8]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        title: "积分兑换",
        modelValue: showPointExchangeModal.value,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => showPointExchangeModal.value = $event)
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[9] || (_cache[9] = $event => showPointExchangeModal.value = false)
        }, {
          default: _withCtx(() => [_hoisted_13]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirmPointExchange
        }, {
          default: _withCtx(() => [_hoisted_14]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "兑换数量"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input_number, {
            controls: false,
            step: 0.01,
            precision: 2,
            modelValue: exchangePointNum.value,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => exchangePointNum.value = $event)
          }, null, 8, ["step", "modelValue"])]),
          _: 1
        }), _createElementVNode("div", _hoisted_11, "最大可兑换积分：" + _toDisplayString(selectedRow.value.redeemableIntegral), 1), _hoisted_12]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(PointTurnoverModal, {
        modelValue: showPointTurnoverModal.value,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => showPointTurnoverModal.value = $event),
        data: selectedRow.value,
        integralMode: __props.integralMode
      }, null, 8, ["modelValue", "data", "integralMode"])]);
    };
  }

};